var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 14.5a.75.75 0 01-.75-.75V8.56l-.47.47a.75.75 0 01-.976.073L.97 9.03a.75.75 0 01-.073-.976L.97 7.97l6.5-6.5.084-.073.002-.001-.086.074a.753.753 0 01.885-.131l.091.058.084.073 6.5 6.5a.75.75 0 01-.976 1.133l-.084-.073-.47-.469v5.189a.75.75 0 01-.648.743l-.102.007zM8 9.75a1 1 0 00-1 1v2.249h2V10.75a1 1 0 00-.883-.993zm0-6.689L4 7.06V13h1.5v-2.25a2.5 2.5 0 012.336-2.495L8 8.25a2.5 2.5 0 012.5 2.5V13H12V7.061l-4-4z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.75L8 2l4.75 4.75v7h-3v-3a1.75 1.75 0 10-3.5 0v3h-3v-7z",
    fillOpacity: 0.15
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome16);
export default __webpack_public_path__ + "static/media/home-16.c9bd1e11.svg";
export { ForwardRef as ReactComponent };